import { createStore } from "redux"
import reducer from "./reducers/index"
import throttle from "lodash/throttle"
import { getReduxStore, setReduxStore } from "utils/common.util"

const persistedState: RootState = !!getReduxStore()
  ? getReduxStore()
  : undefined

export const store: any = createStore(
  (state: RootState | undefined, event: any) =>
    event.type === "REINITIALIZE"
      ? reducer(undefined, event)
      : reducer(state, event),
  persistedState,
  (window as any).__REDUX_DEVTOOLS_EXTENSION__ &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION__()
)

export type RootState = ReturnType<typeof store.getState>

// Listen for changes to sync with local storage
store.subscribe(() => {
  throttleStore()
})

// Delay save to local storage
const throttleStore = throttle(() => {
  setReduxStore(store.getState())
}, 1000)
